const routes = [
  {
    path: "scan",
    component: () => import("./Scan.vue"),
    children: [
      {
        path: "",
        name: "scanner-route",
        component: () => import("./views/Scanner.vue"),
        meta: { title: "Scan" },
      },
      {
        path: ":id(.*)",
        props: true,
        name: "scan-result-route",
        component: () => import("./views/ScanResult.vue"),
        meta: { title: "Scan result - " },
      },
    ],
  },
];

export default routes;
